import ReportList from '@/components/admin/reports/ReportList'
import CreateReport from '@/components/admin/reports/CreateReport'
import auth from './../auth'

export default [
  {
    path: '/admin/reports/new/',
    name: 'CreateReport',
    component: CreateReport,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/reports/',
    name: 'ReportList',
    component: ReportList,
    beforeEnter: auth.ifAuthenticated
  },
]
